import { formatMoney } from '@spa/shared/utils/money';
export var calculateShortTermPenalty = function calculateShortTermPenalty(accommodationOffer) {
  var _accommodationOffer$c, _accommodationOffer$c2;
  if (!(accommodationOffer !== null && accommodationOffer !== void 0 && (_accommodationOffer$c = accommodationOffer.contract) !== null && _accommodationOffer$c !== void 0 && (_accommodationOffer$c2 = _accommodationOffer$c.standard) !== null && _accommodationOffer$c2 !== void 0 && _accommodationOffer$c2.penalty)) {
    return {
      shortTermPenaltyAmount: 0,
      shortTermPenaltyPrice: ''
    };
  }
  var _accommodationOffer$c3 = accommodationOffer.contract.standard.penalty,
    penaltyPrice = _accommodationOffer$c3.value,
    penaltyNights = _accommodationOffer$c3.nights_threshold;
  if (!(penaltyPrice !== null && penaltyPrice !== void 0 && penaltyPrice.amount) || !penaltyNights) {
    return {
      shortTermPenaltyAmount: 0,
      shortTermPenaltyPrice: ''
    };
  }
  return {
    shortTermPenaltyAmount: penaltyNights,
    shortTermPenaltyPrice: formatMoney(penaltyPrice.amount, penaltyPrice.currency_code) || ''
  };
};